import React, { useEffect, useState } from "react";
import ClipboardInput from "../../../../elements/copyToClipboard/ClipboardInput";
import DialogModal from "../../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../../elements/twoFa/TwoFa";
import axios from "axios";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import Notification from "../../../../elements/notification/Notification";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import { useHistory } from "react-router-dom";
import { parseAxiosError } from "../../../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../../../utils/consts";

import MaterialSwitch from "../../../../styles/materialSwitch";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../../../styles/styledTabsForm";
import ProjectApiRecreateDialog from "./ProjectApiRecreateDialog";

const ProjectApiKey = ({ t, projectId, project, setProject }) => {

  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});
  const [dialogContent, setDialogContent] = useState(null);

  const [projectSecret, setProjectSecret] = useState("********");

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "currentTab": checkFilterItem(history, "currentTab", "api-keys", false, true),
  });

  const { isApiActive } = project;

  const getProjectSecret = (event) => {
    event.preventDefault();

    let data = {
      project: projectId,
      twofa: event.target.twofa.value
    };

    axios.post("/api/project-keys", data, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setProjectSecret(response.data.secret);
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const changeProjectActivity = (event) => {
    event.preventDefault();

    let data = {
      isApiActive: !project.isApiActive,
      twofa: event.target.twofa.value
    };

    axios.put(`/api/projects/${projectId}`, data, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProject(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setOpen(false);
    });
  };

  const handleShowSecret = () => {
    setOpen(true);
    setDialogContent(<TwoFa
      handleSubmit={getProjectSecret}
      error={error}
    />);
  };

  const handleChangeActivity = () => {
    setOpen(true);
    setDialogContent(<TwoFa
      handleSubmit={changeProjectActivity}
      error={error}
    />);
  }

  const handleRecreateSecret = () => {
    setOpen(true);
    setDialogContent(<ProjectApiRecreateDialog
      t={t}
      error={error}
      projectId={projectId}
      setProjectSecret={setProjectSecret}
      setOpen={setOpen}
      notification={notification}
      setNotification={setNotification}
    />);
  }

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledFormGrid
        pt="20"
        className="grid-form projects-api-key"
      >
        <DialogModal
          open={open}
          setOpen={setOpen}
          title={t("details.twoFa")}
          content={dialogContent}
        />
        <StyledFormBlock className="projects-api-key__block">
          <StyledBlockLabel>
            API
          </StyledBlockLabel>
          <StyledInputBlock>
            <div className="projects-api-key__row">
              <ClipboardInput
                label={t("details.apiKey.projectId")}
                value={projectId}
                readonly={true}
              />
              <div className="clear-column" />
            </div>
            <div className="projects-api-key__row">
              <ClipboardInput
                label={t("details.apiKey.projectSecret")}
                value={projectSecret}
                readonly={true}
              />
              <button
                className="projects-api-key__show"
                onClick={handleShowSecret}
                title={t("details.apiKey.showSecret")}
              >
                <span className="icon-light-eye" />
              </button>
              <button
                className="projects-api-key__show"
                onClick={handleRecreateSecret}
                title={t("details.apiKey.recreateSecret")}
              >
                <span className="icon-light-reload" />
              </button>
            </div>
            <div>
              {t("details.apiKey.active")}
              <MaterialSwitch
                checked={isApiActive ?? true}
                name={t("details.apiKey.active")}
                onChange={handleChangeActivity}
              />
            </div>
          </StyledInputBlock>
          <div className="clear-column" />
        </StyledFormBlock>
      </StyledFormGrid>
    </>
  );
};

export default ProjectApiKey;